type PropTypes = {
  className?: string
}

const WarningTriangleIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      className={className}
    >
      <path fill="currentColor" d="M7.001 2.086h-.002L1.324 12.998l.001.002h11.35v-.002L7.002 2.086ZM6.437 5h1.125v4.5H6.438V5ZM7 12a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
      <path fill="currentColor" d="M13.5 14H.5a.5.5 0 0 1-.444-.73l6.5-12.5a.5.5 0 0 1 .888 0l6.5 12.5a.5.5 0 0 1-.444.73ZM1.325 13h11.35v-.002L7.002 2.086h-.002L1.324 12.998l.001.002Z" />
    </svg>
  )
}

export default WarningTriangleIcon
